import { lazy, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const GuidelineHeader = lazy(() => import("./GuidelineHeader"));
const GuidelineContent = lazy(() => import("./GuidelineContent"));


export const GuidelineTemplate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;
  const search = location.search;
  return (
    <Suspense fallback={<div className="loader"></div>}>
      <GuidelineHeader push={navigate}  pathname={pathname} ></GuidelineHeader>
      <GuidelineContent search={search} pathname={pathname} />
    </Suspense>
  );
};
